import React from 'react';
import { PureQueryOptions } from '@apollo/client';
import { useState } from 'react';
import {
  calculateEndTime,
  createNewTimeEntry,
  DayWithTimeEntries,
  TimeEntryItem,
  TimeEntryReadOnlyReason,
} from '../logic';
import DayTimeEntriesDumb from './DayTimeEntriesDumb';
import { CostCenterProps } from '..';
import { WarningModal } from '../../components/WarningModal/WarningModal';
import { useTimeTrackingRestriction } from '../../../../hooks/timeTrackingSettings';
import { toISODateOnly } from '../../../../../../utils/dateUtils';

type Props = {
  day: DayWithTimeEntries;
  costCenters: readonly CostCenterProps[];
  refetchQueriesForEmployeeMode?: PureQueryOptions[];
  readonlyReasons: TimeEntryReadOnlyReason[];
};

const DayTimeEntriesSmart: React.FC<Props> = ({
  day,
  costCenters,
  readonlyReasons,
  refetchQueriesForEmployeeMode,
}) => {
  const [timeEntryNew, setTimeEntryNew] = useState<TimeEntryItem | null>(null);
  const {
    showRestrictedWarningModal,
    setShowRestrictedWarningModal,
    getTimeTrackingRestrictedReason,
  } = useTimeTrackingRestriction();

  const restrictionReason = getTimeTrackingRestrictedReason(
    toISODateOnly(day.day.toDate()),
  );

  const handleAddNewTimeEntryClick = () => {
    if (restrictionReason) {
      setShowRestrictedWarningModal(true);
    } else {
      const startTime =
        day.timeEntries.length > 0
          ? day.timeEntries[day.timeEntries.length - 1].end?.time
          : day.workload?.startTime;
      const endTime = calculateEndTime(
        startTime,
        day.workload?.endTime ?? null,
      );
      setTimeEntryNew(
        createNewTimeEntry(day.day, day.timeSheetId, startTime, endTime),
      );
    }
  };

  const handleCancelCreatingNewTimeEntry = () => {
    setTimeEntryNew(null);
  };

  const timeEntries = timeEntryNew
    ? [...day.timeEntries, timeEntryNew]
    : day.timeEntries;

  return (
    <>
      <WarningModal
        visible={showRestrictedWarningModal}
        restrictionReason={restrictionReason}
        onClose={() => setShowRestrictedWarningModal(false)}
      />
      <DayTimeEntriesDumb
        day={day}
        costCenters={costCenters}
        employeeType={day.employeeType}
        readonlyReasons={readonlyReasons}
        timeEntries={timeEntries}
        refetchQueriesForEmployeeMode={refetchQueriesForEmployeeMode}
        onAddNewTimeEntryClick={handleAddNewTimeEntryClick}
        onCancelCreatingNewTimeEntry={handleCancelCreatingNewTimeEntry}
      />
    </>
  );
};

export default DayTimeEntriesSmart;
